/*
 * OASIS NATION — ambient sound toggle
 * Self-gating: the toggle only appears if oasis-ambient.mp3 actually loads.
 * Always starts muted; user opts in. Choice persists per session.
 */
(function () {
  'use strict';
  function init() {
    var btn = document.querySelector('[data-oasis-sound]');
    var audio = document.querySelector('[data-oasis-audio]');
    if (!btn || !audio) return;

    // Reveal the toggle only once we know the audio file exists
    audio.addEventListener('loadedmetadata', function () { btn.hidden = false; });
    audio.addEventListener('error', function () { btn.remove(); audio.remove(); });

    audio.volume = 0;
    var playing = false, fadeTimer = null;

    function fadeTo(target, onDone) {
      clearInterval(fadeTimer);
      fadeTimer = setInterval(function () {
        var v = audio.volume;
        if (Math.abs(v - target) < 0.04) { audio.volume = target; clearInterval(fadeTimer); if (onDone) onDone(); return; }
        audio.volume = v + (target - v) * 0.15;
      }, 40);
    }

    function play() {
      audio.play().then(function () {
        playing = true; btn.classList.add('is-playing'); fadeTo(0.5);
        try { sessionStorage.setItem('oasisSound', '1'); } catch (e) {}
      }).catch(function () {});
    }
    function stop() {
      playing = false; btn.classList.remove('is-playing');
      fadeTo(0, function () { audio.pause(); });
      try { sessionStorage.setItem('oasisSound', '0'); } catch (e) {}
    }

    btn.addEventListener('click', function () { playing ? stop() : play(); });

    // Resume if the user had it on earlier this session (after a gesture)
    try {
      if (sessionStorage.getItem('oasisSound') === '1') {
        var resume = function () { play(); document.removeEventListener('click', resume); };
        document.addEventListener('click', resume, { once: true });
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
